import { Button, Card, Checkbox } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { gql } from "__generated__/gql";
import { useStoreActions } from "ezStore";

const TermsOfService = () => {

	const [ check, setCheck ] = useState(false);
	const actions = useStoreActions(actions => actions);

	const [ agree ] = useMutation(AGREE_TO_TERMS_OF_SERVICE, {
		onCompleted: () => actions.session.agreeToTermsOfService(),
	});

	return <div className="terms-of-service-container">
		<Card>
			<div className="tos-pdf">
				<iframe
					src="/termsofservice#toolbar=0&navpanes=0&scrollbar=0"
					width="800"
					height="600" />
			</div>
			<div className="tos-actions">
				<Checkbox checked={check} onChange={e => setCheck(e.target.checked)}
					label={intl.formatMessage({ id: "TOS_AGREE" })} />
				<Button onClick={() => void agree()} disabled={!check}>{intl.formatMessage({ id: "CONTINUE" })}</Button>
			</div>
		</Card>
	</div>
}

const AGREE_TO_TERMS_OF_SERVICE = gql(`#graphql
	mutation agreeToTermsOfService {
		agreeToTermsOfService
	}
`);

export default TermsOfService;
